import { memo } from "react";
import type { MCPConnectionTool } from "../../../services/agent-tools-service";
import { useTranslation } from "react-i18next";

type Props = {
  tool: MCPConnectionTool;
  onChangeAccess: (tool: MCPConnectionTool) => void;
};

const ToolRow = ({ tool, onChangeAccess }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-3 py-3">
      <div className="min-w-0">
        <div className="truncate text-sm font-medium text-foreground">
          {tool.name}
        </div>
        {tool.description && (
          <div className="mt-0.5 line-clamp-2 text-xs text-muted-foreground">
            {tool.description}
          </div>
        )}
        <button
          type="button"
          onClick={() => onChangeAccess(tool)}
          className="mt-1 text-xs text-primary underline underline-offset-2 hover:brightness-110"
        >
          {t("mcpPage.actions.change")}
        </button>
      </div>
    </div>
  );
};

export default memo(ToolRow);
